import Skeleton from "@/components/Skeleton/Skeleton";
import { Input, InputNumber, InputNumberProps, InputProps } from "antd";
import { TextAreaProps } from "antd/es/input";

interface SkeletonInputNumberProps extends InputNumberProps {
  showSkeleton?: boolean;
  width?: string;
}

export function RootInputNumber({ showSkeleton, width, ...props }: SkeletonInputNumberProps) {
  if (showSkeleton) return <Skeleton style={{ width: width, height: "30px" }} />;

  return (
    <InputNumber
      style={{ width: width }}
      {...props}
    />
  );
}

interface SkeletonInputProps extends InputProps {
  showSkeleton?: boolean;
  width?: string;
}

export function RootInput({ showSkeleton, width, ...props }: SkeletonInputProps) {
  if (showSkeleton) return <Skeleton style={{ width: width, height: "30px" }} />;

  return (
    <Input
      style={{ width: width }}
      {...props}
    />
  );
}

interface SkeletonTextAreaProps extends TextAreaProps {
  showSkeleton?: boolean;
  width?: string;
}

export function RootTextArea({ showSkeleton, width, ...props }: SkeletonTextAreaProps) {
  if (showSkeleton) return <Skeleton style={{ width: width, height: "30px" }} />;

  return (
    <Input.TextArea
      style={{ width: width }}
      {...props}
    />
  );
}
